import { Spinner } from '../../../../App/WEB/_Templates/_UI/Kit/Feedback';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useUserAuthenticated } from '../userAuthenticatedContext';
import { getUserAccess } from '../../../../_Helpers/Helpers/_moduleFactory.helper.js';
import { USER_HOME_HELPER } from '../../../../_Helpers/Helpers/userHome.helper';

const useAccess = () => {

    const { useDataUserAuth } = useUserAuthenticated();

    const SESSION = useDataUserAuth ?? {};
    const ACCESS = getUserAccess(SESSION.data ?? {});

    const hasRoleAccess = (roles) => {
        if (!roles || roles.length === 0) return true;
        if (ACCESS.isGod) return true;
        return (Array.isArray(roles) ? roles : [roles]).some((r) => ACCESS.roleKeys.has(r));
    };

    const hasPermissionAccess = (permissionsList) => {
        if (!permissionsList || permissionsList.length === 0) return true;
        if (ACCESS.isGod) return true;
        return (Array.isArray(permissionsList) ? permissionsList : [permissionsList]).some((p) => ACCESS.permKeys.has(p));
    };

    const hasEveryPermissionAccess = (permissionsList) => {
        if (!permissionsList || permissionsList.length === 0) return true;
        if (ACCESS.isGod) return true;
        return (Array.isArray(permissionsList) ? permissionsList : [permissionsList]).every((p) => ACCESS.permKeys.has(p));
    };

    return {
        isAuth: Boolean(SESSION.isAuthenticated),
        isLoading: Boolean(SESSION.isLoading),
        userData: SESSION.data ?? null,
        hasRole: hasRoleAccess,
        hasPermission: hasPermissionAccess,
        hasEveryPermission: hasEveryPermissionAccess,
    };
};


export const AppGuard = ({ children, roles = null, permissions = null, requireAll = false,
    redirectTo = '/login', forbiddenTo = '/access-denied', fallback = null,
}) => {

    const { isAuth, isLoading, hasRole, hasPermission, hasEveryPermission } = useAccess();

    const location = useLocation();

    if (isLoading) {
        return fallback ?? <Spinner label="Verificando sesión…" />;
    }

    if (!isAuth) {
        return <Navigate to={redirectTo} state={{ from: location }} replace />;
    }

    const HAS_ROLE = hasRole(roles);

    const HAS_PERMS = requireAll ? hasEveryPermission(permissions) : hasPermission(permissions);

    if (!HAS_ROLE || !HAS_PERMS) {
        return <Navigate to={forbiddenTo} replace />;
    }

    return children ?? <Outlet />;
};


export const AppGuestGuard = ({ children, redirectTo = '/dashboard' }) => {

    const { isAuth, isLoading, userData } = useAccess();

    const location = useLocation();

    if (isLoading) return <Spinner label="Verificando sesión…" />;

    if (isAuth) {
        const BACK = location.state?.from?.pathname;
        return <Navigate to={BACK ?? USER_HOME_HELPER.HOME(userData, redirectTo)} replace />;
    }

    return children ?? <Outlet />;
};

export const AppCan = ({ children, roles = null, permissions = null, requireAll = false, fallback = null }) => {

    const { isAuth, hasRole, hasPermission, hasEveryPermission } = useAccess();

    if (!isAuth) return fallback;

    const HAS_PERMS = requireAll ? hasEveryPermission(permissions) : hasPermission(permissions);

    if (!hasRole(roles) || !HAS_PERMS) return fallback;

    return children;
};
